/* eslint-disable */
import React, { Component, Button } from 'react';
import { connect } from 'react-redux';
import Loader from '../../common/LoadingSpinner';
import actions from '../../../actions';
import ActionButton from '../../common/ActionButton';
import LocationMapContainer from './map.jsx';
import { getCountDownTimer } from './utils';
import history from '../../../history';

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.toggleShowFreelancerTable =
            this.toggleShowFreelancerTable.bind(this);
    }

    componentDidMount() {
        this.props.loadTrackingMapData();
    }

    toggleShowFreelancerTable(marker) {
        history.push(`/operations/locationtracking/map/${marker.booking.id}/`);
    }

    render() {
        let jobsWithPositions = [];

        if (this.props.trackingMap.content.length != 0) {
            jobsWithPositions = this.props.trackingMap.content.filter(
                job =>
                    job.booking &&
                    job.booking.eta &&
                    job.booking.latest_position &&
                    !job.booking.clock_in,
            );
            jobsWithPositions.forEach(obj => {
                obj.showInfo = false;
            });
        }

        return (
            <div className="table-container">
                <div className="table-filter-container">
                    <div className="table-action-bar">
                        <div className="grouped-buttons">
                            <ActionButton
                                tooltip="List view"
                                iconClass="icon-view-list"
                                onAction={() =>
                                    history.push(
                                        '/operations/locationtracking/',
                                    )
                                }
                            />
                            <ActionButton
                                active={true}
                                tooltip="Map view"
                                iconClass="icon-map-pin-1"
                            />
                        </div>
                    </div>
                </div>
                <span>
                    {this.props.trackingMap.fetching &&
                    !this.props.trackingMap.content.length != 0 ? (
                        <div className="text-align-center">
                            <Loader color="gray" size="20px" margin="20px" />
                        </div>
                    ) : null}
                    <LocationMapContainer
                        data={jobsWithPositions}
                        showDirections={false}
                        loadTrackingMapData={this.props.loadTrackingMapData}
                        toggleShowFreelancerTable={
                            this.toggleShowFreelancerTable
                        }
                        countDownTimer={getCountDownTimer}
                    />
                </span>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    if (state.tracking) {
        const newState = {
            ...state.tracking,
            user: state.user,
            trackingMap: state.trackingMap,
        };
        return newState;
    }
    return {
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadTrackingMapData: payload =>
        dispatch(actions.loadTrackingDataForMap(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);
